import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { DEFAULT_REQUIRED_MESSAGE, EmailInputField, PasswordInputField, TextInputField } from 'common/components/form_fields';
import isEmail from 'sane-email-validation';

const exampleFormsValidation = values => {
  const errors = {};

  // Email gets special treatment
  if (!values.example_two) {
    errors.example_two = DEFAULT_REQUIRED_MESSAGE;
  } else if (!isEmail(values.example_two)) {
    errors.example_two = "Whoops! This field has an error";
  }

  return errors;
};

let ExampleForms = props => (
  <section id="forms">
    <h3 className="section-header">Forms &amp; Inputs</h3>
    <div className="row">
      <div className="columns medium-15 large-5">
        <div className="form-group">
          <input type="text" className="form-control" id="example_one" required={true} />
          <span className="bar"></span>
          <label className="form-label animate" htmlFor="example_one">text input</label>
        </div>
      </div>
      <div className="columns medium-5">
        <Field name="example_one" component={TextInputField} label="Text input" />
      </div>
      <div className="columns medium-15 large-5">
        <div className="form-group">
          <div className="select-wrapper">
            <select className="form-control" required={true}>
              <option value="" disabled={true} selected={true}>Select an Option</option>
              <option value="IL">IL</option>
              <option value="ME">ME</option>
              <option value="PA">PA</option>
            </select>
            <label className="form-label animate">select input</label>
          </div>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="columns medium-5">
        <Field verified={true} name="example_three" component={TextInputField} label="Text input" />
      </div>
      <div className="columns medium-5">
        <Field name="example_two" component={EmailInputField} label="Email input (validated)" />
      </div>
    </div>

    <div className="row">
      <div className="columns medium-15 large-10">
        <div className="form-group">
          <textarea className="form-control" required ></textarea>
          <label className="form-label">Text Area</label>
        </div>
      </div>
      <div className="columns medium-10">
        <div className="form-group">
          <div className="checkbox">
            <input id="box_1" type="checkbox" className="form-control" />
            <label htmlFor="box_1" className="form-label">This is a checkbox</label>
          </div>
          <div className="checkbox">
            <input id="box_2" type="checkbox" className="form-control" />
            <label htmlFor="box_2" className="form-label">This is another checkbox</label>
          </div>
          <div className="checkbox">
            <input id="box_3" type="checkbox" className="form-control" />
            <label htmlFor="box_3" className="form-label">Yet another checkbox</label>
          </div>
        </div>
        <div className="form-group">
          <div className="radio">
            <input id="r_1" name="question" type="radio" className="form-control" value="sel" />
            <label htmlFor="r_1" className="form-label">Radio 1</label>
          </div>
          <div className="radio">
            <input id="r_2" name="question" type="radio" className="form-control" value="sel" />
            <label htmlFor="r_2" className="form-label">Radio 1</label>
          </div>
          <div className="radio">
            <input id="r_3" name="question" type="radio" className="form-control" value="sel" />
            <label htmlFor="r_3" className="form-label">Radio 1</label>
          </div>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="columns medium-5">
        <div className="star-rating">
          <h4>.star-rating</h4>
          <i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star-o"></i><i className="fa fa-star-o"></i> <span className="label label-default">Okay</span>
        </div>
      </div>
      <div className="columns medium-5">
        <div className="star-rating lg">
          <h4>.star-rating.lg</h4>
          <i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star-o"></i><i className="fa fa-star-o"></i> <span className="label label-default label-md">Okay</span>
        </div>
      </div>
      <div className="columns medium-5">
        <div className="star-rating xxl">
          <h4>.star-rating.xxl</h4>
          <i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star-o"></i><i className="fa fa-star-o"></i> <span className="label label-default label-lg">Okay</span>
        </div>
      </div>
    </div>
  </section>
);

ExampleForms = reduxForm({
  form: 'exampleForm',
  validate: exampleFormsValidation,
})(ExampleForms);

export { ExampleForms };



// WEBPACK FOOTER //
// ./styleguide/components/forms.jsx